import _ from 'lodash';

export const titleCase = (text) => _.startCase(_.toLower(text));
